module.exports = __webpack_public_path__ + "static/media/pinaza_5.5e8f7531.gif";